module.exports = __webpack_public_path__ + "img/Collapse-drawer.5ded896a.svg";